import React, { Fragment } from 'react';
import { getSysFieldid, localeLang } from '@platform/api';
import FormCardImage from './FormCardImage';
import FormCardItem from './FormCardItem';
import FormCardTooltip from './FormCardTooltip';
require('../../formCard.less');
const chartArray1 = ['pie', 'ring'];
const chartArray2 = ['bar1', 'bar2'];
const chartArray = ['pie', 'ring', 'bar1', 'bar2'];

const cardSizeMap = {
    'lg': 4,
    'md': 3,
    'sm': 2,
    'xs': 1,
    '100%': 16,
};

const defaultProps = {
    size: 'md',
    layoutType: 'graphic',
};
const cardImagePath = 'LowCodeComponents.NCFormCard.NCFormCardGraphicItem';
class FormCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = { showTipMap: {} };
    }

    render() {
        return this.renderCard();
    }

    renderCard = () => {
        console.log("FormCard 渲染参数", this.props);
        let { title, size = 'md', layoutType = 'graphic', leftWidth = 10, com_id, layout = [], useCol = true, row1, row2, row3, children, meta, moduleId, store, language, imageitem={} } = this.props,
            { showTipMap } = this.state;
        let imageProps = null;
        let graphic = null;
        let graphicType = null;
        let chartType = null;
        let newTitle = null;
        if (children) {
            let multiLangIndex = language?.find(lang=>lang.languageCode === localeLang)?.index || '1';
            let currentLangIndex = multiLangIndex == '1' ? '' : multiLangIndex;
            let titleField = 'title' + currentLangIndex;
            graphic = this.getGraphic(row1, row2, row3, children);
            graphicType = graphic?.props?.graphicType;
            chartType = graphicType === "chart" && graphic?.props?.chartType;
            newTitle = this.props?.[titleField];
        } else {
            imageProps = layout.find(item => item.parentId === com_id && item.path === cardImagePath) || {};
            graphicType = imageProps?.props?.graphicType;
            chartType = graphicType === "chart" && imageProps?.props?.chartType;
            newTitle = meta?.multiLangItems?.find(langItem => langItem.nodeid === com_id && langItem.itemcode === 'title')?.tranitemvalue || title;
            // 取模板上的字段信息合并一下
            let imageMetaProps = meta?.[imageProps?.props?.areaCode]?.items.find(item=>item.attrcode === imageProps?.props?.itemCode) || {};
            imageProps.props = { ...imageProps.props, ...imageMetaProps };
        }
        let span = cardSizeMap[size] || ('' + size);
        let leftDomWidth = (graphicType === 'chart' && chartArray2.includes(chartType)) ? '100%' : '';
        // 条形图 柱状图 直接100% 
        // NCC-294407 四个图表都可支持调整调整左侧图大小（百分比），但仅支持图表，不支持图片和图标的百分比调整。
        // let leftDomWidth = chartArray.includes(chartType) ? `${leftWidth}%` : '';
        // 环形图 饼图默认宽度 40px 最大宽度66px
        // if(chartArray1.includes(chartType)){
        //     leftDomWidth = (40 + (66-40)*leftWidth) + 'px';
        // }
        // let ringOrPieType = chartArray1.includes(chartType) ? 'form-card-pie-ring' : '';
        // let barType = chartArray2.includes(chartType) ? 'form-card-bar' : '';

        // 只有图标类型的 调整成32px 外边距24 8 20 16
        // 图片、饼、环形图 40*40 外边距 20 8 20 16
        let formCardGraphicIcon = graphicType === 'icon' ? 'form-card-graphic-icon' : '';
        let cardDom = <Fragment>
            {/* 图片或者图表 [text, graphic]文本，图文，卡片布局 */}
            {layoutType === 'graphic' && <div
                className={
                    `form-card-graphic ${formCardGraphicIcon}`
                }
                style={{ width: leftDomWidth }}>
                {
                    graphic ? graphic :
                        <FormCardImage
                            {...this.props}
                            {...imageProps?.props}
                            {...imageitem}
                        >
                        </FormCardImage>
                }
            </div>
            }
            {/* 内容区域 */}
            {
                leftDomWidth !== '100%' && <div
                    className='form-card-content-wrapper'
                >
                    {['cardTitle', 'row1', 'row2', 'row3'].map(item => {
                        return <div
                            key={item}
                            className={`form-card-content-${item}`}
                            onMouseEnter={() => {
                                showTipMap = { ...showTipMap, [item]: true };
                                this.setState({ showTipMap: showTipMap });
                            }}
                            onMouseLeave={() => {
                                showTipMap = { ...showTipMap, [item]: false };
                                this.setState({ showTipMap: showTipMap });
                            }}
                        >
                            {this.renderField({ whichLine: item, ...this.props, title: newTitle })}
                        </div>;
                    })
                    }

                </div>
            }
            {/* 分隔线 最后一个卡片不显示分隔线 */}
            <div className='form-card-divider'></div>
        </Fragment>;
        const cls = 'form-card-wrapper ' + (span ? ' form-card-col-' + span : ' form-card-col-16');
        let fieldid = moduleId + '-form-card-area';
        fieldid = getSysFieldid(fieldid);
        return useCol ? React.createElement("div", { span, fieldid, className: cls }, cardDom) : React.createElement("div", { fieldid, className: cls }, cardDom);

    }

    renderField = params => {
        let { whichLine = 'row1', items = {}, meta, pageScope, title, pageId, store, forceHideLink, layout = [], langJson } = params;
        let { moduleId } = this.props;
        if (params[whichLine]) {
            // 渲染设计器插槽
            return params[whichLine];
        }
        // let columns = meta[moduleId]?.items?.filter(column => items[whichLine].includes(column.attrcode)) || [];
        let result = null;
        let tooltipResult = null;
        if (whichLine === 'cardTitle') {
            // 标题渲染
            result = title;
            tooltipResult = title;
        } else {
            // 第一行 第二行 第三行渲染
            let layoutPropsMap = {};
            layout.forEach(item => {
                if (item?.props?.areaCode === moduleId && item.name === "NCFormCardItem") {
                    layoutPropsMap[item.props.itemCode] = item.props;
                }
            });
            if(!items[whichLine]){
                return null;
            }
            let columns = [];
            items[whichLine].forEach(field => {
                let renderField = meta[moduleId]?.items?.find(item => item.attrcode === field && item.visible !== false) || {};
                let storeField = store.getCardItem(moduleId, field);
                let layoutProps = layoutPropsMap[field] || {};
                if (storeField) {
                    let { disabled, visible, required, verify, color, contentcolor } = storeField;
                    renderField = { ...layoutProps, ...renderField, disabled, visible, required, verify, color, contentcolor };
                }
                renderField.visible !== false && columns.push(renderField);
            });
            // 显示的内容
            result = columns.map(column => {
                return <FormCardItem key={column.attrcode} column={column} pageId={pageId} currentMeta={meta[moduleId]} meta={meta} pageScope={pageScope} store={store} forceHideLink={forceHideLink} langJson={langJson}></FormCardItem>;
            });
            // tooltip里不需要显示 ？的tooltip
            tooltipResult = columns.map(column => {
                return <FormCardItem key={column.attrcode} column={column} pageId={pageId} tooltips={false} currentMeta={meta[moduleId]} meta={meta} pageScope={pageScope} store={store} forceHideLink={forceHideLink} langJson={langJson}></FormCardItem>;
            });
        }
        // mouseenter 时判断是否要切换成 tooltip
        return this.renderTooltip(
            result,
            <div className='form-card-tooltip-content'>{result}</div>,
            tooltipResult,
            whichLine,
        );
    }

    renderTooltip = (innerContent, content = '', overlay, whichLine) => {
        let { showTipMap } = this.state;
        let showTip = showTipMap[`${whichLine}`];
        return innerContent?.length ? <FormCardTooltip overlay={overlay} visible={showTip}>{content}</FormCardTooltip> : null;
    }

    getGraphic = (row1, row2, row3, children = []) => {
        let graphic = null;
        let rowIds = new Set();
        rowIds.add(row1?.props?.clayid || row1?.props?.$id);
        rowIds.add(row2?.props?.clayid || row2?.props?.$id);
        rowIds.add(row3?.props?.clayid || row3?.props?.$id);
        children.forEach(item => {
            if (!rowIds.has(item?.props?.clayid || item?.props?.$id)) {
                graphic = item;
            }
        });
        return graphic;
    }
}

FormCard.defaultProps = defaultProps;
FormCard.displayName = 'FormCard';
FormCard.FormCardImage = FormCardImage;
FormCard.FormCardItem = FormCardItem;
FormCard.cardSizeMap = cardSizeMap;

export default FormCard;